import { useQuery } from "@tanstack/react-query";
import { gqlRequest } from "@/api/graphql/request";
import { RANK_CHANGES } from "@/api/graphql/operations/monitoring";

export interface RankChange {
  keyword: string;
  contentUrl: string;
  previousRank: number;
  currentRank: number;
  change: number;
  detectedAt: string;
}

export function useAlerts(limit = 8) {
  return useQuery({
    queryKey: ["dashboard", "alerts", limit],
    queryFn: () =>
      gqlRequest<{ rankChanges: RankChange[] }>(RANK_CHANGES, { limit }).then(
        (d) => d.rankChanges,
      ),
    staleTime: 60_000,
  });
}
